import paper from 'paper'

export default class SemiRecessedCircle {
  constructor(insertMaterial, diameter = 35, insetX = 30, insetY = 25) {
    this.insertMaterial = insertMaterial
    this.path
    this.width = diameter
    this.height = diameter
    this.insetX = insetX
    this.insetY = insetY

    this.draw()
  }

  draw() {
    this.path = new paper.Path.Circle(new paper.Point(this.width / 2, this.height / 2), this.width / 2)
    this.path.fillColor = this.insertMaterial.uiColour
    this.path.strokeColor = 'black'
  }
}
